<div [id]="getWidgetId">
    @if (!loading() && enabledCategoriesLoaded()) {
        @if (cards()?.length) {
            <div [class]="classes?.catalogWrapper" [class.mobileView]="isDeviceMobile$ | async">
                <div class="filterWrapper">
                    <div class="categoriesWrapper">
                        <label>{{ widgetData.filter.category.label }}</label>
                        @if (widgetData.catalogView === CatalogCategoriesView.left) {
                            <ul class="categories-tree" [class.mobileView]="isDeviceMobile$ | async">
                                @if (!widgetData.selectedCategory && hasEnabledCategories()) {
                                    <li>
                                        <a [class.active]="activeCategory() === null">{{
                                            "catalog_all_categories" | translate
                                        }}</a>
                                    </li>
                                }
                                @for (category of categories(); track category) {
                                    <li>
                                        <a
                                            [class.active]="category.id === activeCategory()"
                                            [class.non-selectable]="!isCategorySelectable(category)"
                                            >{{ category.name | translate }}</a
                                        >
                                        <ng-container
                                            *ngTemplateOutlet="
                                                renderNestedCategories;
                                                context: { $implicit: category.children }
                                            "
                                        ></ng-container>
                                    </li>
                                }
                            </ul>
                        }
                        <div class="categories-dropdown-wrapper" [class.mobileView]="isDeviceMobile$ | async">
                            <select>
                                @if (!widgetData.selectedCategory && hasEnabledCategories()) {
                                    <option [value]="null">
                                        {{ "catalog_all_categories" | translate }}
                                    </option>
                                }
                                @for (category of categories(); track category) {
                                    <ng-container
                                        *ngTemplateOutlet="renderOption; context: { $implicit: category, level: 0 }"
                                    ></ng-container>
                                }
                            </select>
                            <ng-template #renderOption let-category let-level="level">
                                <option
                                    [value]="category.id"
                                    [selected]="category.id === activeCategory()"
                                    [disabled]="!isCategorySelectable(category)"
                                >
                                    {{ getIndent(level) }}{{ category.name }}
                                </option>
                                @if (category.children?.length) {
                                    @for (child of category.children; track child) {
                                        <ng-container
                                            *ngTemplateOutlet="
                                                renderOption;
                                                context: { $implicit: child, level: level + 1 }
                                            "
                                        ></ng-container>
                                    }
                                }
                            </ng-template>
                        </div>
                        <ng-template #renderNestedCategories let-children>
                            @if (children && children.length) {
                                <ul>
                                    @for (child of children; track child) {
                                        <li>
                                            <a
                                                [class.active]="child.id === activeCategory()"
                                                [class.non-selectable]="!isCategorySelectable(child)"
                                                >{{ child.name }}</a
                                            >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    renderNestedCategories;
                                                    context: { $implicit: child.children }
                                                "
                                            ></ng-container>
                                        </li>
                                    }
                                </ul>
                            }
                        </ng-template>
                    </div>
                    <div class="priceFilter" [class]="classes?.priceFilter">
                        <label>{{ widgetData.filter.price.label }}</label>
                        @if (widgetData.catalogView === CatalogCategoriesView.left && filterSettings?.price?.slider) {
                            <div class="price-range">
                                <div class="range-double">
                                    <input
                                        type="range"
                                        [min]="0"
                                        [max]="100"
                                        [step]="1"
                                        [value]="10"
                                        aria-label="min price"
                                    />
                                    <input
                                        type="range"
                                        [min]="0"
                                        [max]="100"
                                        [step]="1"
                                        [value]="90"
                                        aria-label="max price"
                                    />
                                    <div class="range-track">
                                        <div
                                            class="range-progress"
                                            [style.left.%]="(10 / 100) * 100"
                                            [style.right.%]="100 - (90 / 100) * 100"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="price-inputs-wrapper">
                            <input type="number" [value]="10" />
                            <span>-</span>
                            <input type="number" [value]="90" />
                        </div>
                    </div>
                </div>
                <div [class]="classes?.cardsWrapper">
                    <div class="sorting-panel">
                        @if (!widgetData.sorting.searchEnable) {
                            <div class="total">{{ "catalog_products_count_label" | translate }}: {{ total() }}</div>
                        }
                        @if (widgetData.sorting.searchEnable) {
                            <div class="search">
                                <input type="text" [placeholder]="widgetData.sorting.searchPlaceholder" />
                            </div>
                        }
                        @if (widgetData.sorting.enable) {
                            <div class="sorting-wrapper">
                                <select>
                                    @for (option of sortingOptions; track option) {
                                        <option>{{ option | translate }}</option>
                                    }
                                </select>
                            </div>
                        }
                    </div>
                    <div class="cards-container">
                        @for (card of cards(); track card) {
                            @if (card.visible) {
                                <web-catalog-product-card
                                    [element]="card"
                                    [classes]="classes"
                                    [settings]="widgetData.settings"
                                    [basketButton]="widgetData.basketButton"
                                    [class]="classes?.cardWrapper"
                                    [class.mobileView]="isDeviceMobile$ | async"
                                    [class.notdisabled]="card.prices[0].currency !== (shopCurrency$ | async)"
                                    [tooltip]="
                                        card.prices[0].currency !== (shopCurrency$ | async)
                                            ? ('widget_product_catalog_card_tooltip' | translate)
                                            : null
                                    "
                                ></web-catalog-product-card>
                            }
                        }
                    </div>
                    <div [class]="classes?.paginationStyles">
                        @if (widgetData?.pagination?.nextPage?.isShowButton) {
                            <div class="nextButtonWrapper">
                                <a class="next-button" [class]="nextButtonStyles">
                                    @if (widgetData?.pagination?.nextPage.buttonIcon?.isActive) {
                                        <span
                                            class="icon"
                                            [innerHTML]="getIcon(widgetData?.pagination?.nextPage.buttonIcon?.icon)"
                                        ></span>
                                    }
                                    {{ widgetData?.pagination?.nextPage?.label }}
                                </a>
                            </div>
                        }
                        <nav aria-label="pagination">
                            <ul>
                                <li class="disabled arrow-btn">
                                    <a aria-label="Previous">
                                        <span aria-hidden="true" class="sp-icon icon-arrow-left"></span>
                                    </a>
                                </li>
                                <li class="active"><a>1</a></li>
                                <li><a>2</a></li>
                                <li><a>3</a></li>
                                <li class="arrow-btn">
                                    <a aria-label="Next">
                                        <span aria-hidden="true" class="sp-icon icon-arrow-right"></span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        } @else {
            <div class="empty-state text-center w-100">
                <img [src]="'./assets/img/websites/lpc-empty-product-icon.svg'" alt="product_blank" />
                <span>{{ "catalog_empty_state_select_categories" | translate }}</span>
            </div>
        }
    } @else {
        <div class="loader">
            <div class="preloader preloader-puff-rounds"></div>
        </div>
    }
</div>
